<template>
    <router-view v-if="!loadingInit" />
</template>
<style lang="scss">
// 3rd party plugins css
@import "~vue-select/src/scss/vue-select.scss";
@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import '~perfect-scrollbar/css/perfect-scrollbar.css';
@import '~animate.css';
@import '~@fortawesome/fontawesome-free/css/all.css';

@import 'assets/sass/style.vue';
</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from '@/modules/layout/layout-store';
import { mapActions, mapGetters } from 'vuex';
import { eventHub } from '@/shared/utils/eventHub';
import { getPcuelAccountId, destroyPcuelAccountId } from '@/shared/services/pcuel-account.service';

export default {
    name: 'App',
    computed: {
        ...mapGetters({
            loadingInit: 'auth/loadingInit',
            listPeriod: 'notifications/inApp/listPeriod',
            isAuthenticated: 'auth/isAuthenticated',
            isAtlasPublicView: 'shared/isAtlasPublicView',
            currentUser: 'auth/currentUser',
        })
    },
    methods: {
        ...mapActions({
            doInit: 'auth/doInit',
            changeTokenState: 'auth/setExpiredToken',
            fetchSettings: 'shared/fetchSettings',
            updateProfile: 'auth/updateProfile',
        }),
        handleAccountIdSync() {
            const accountId = getPcuelAccountId();
            if (!accountId || !this.isAuthenticated) return;

            const alreadySynced = this.currentUser?.pcuel_account_id;
            if (alreadySynced) {
                const isDifferentAccount = alreadySynced !== accountId;
                destroyPcuelAccountId();
                this.$alert({
                    type: isDifferentAccount ? 'warning' : 'info',
                    text: this.$t(isDifferentAccount ? 'PCUEL.DIFFERENT_ACCOUNT_TEXT' : 'PCUEL.ALREADY_SYNCED_TEXT'),
                    confirmButtonText: this.$t('GENERAL.BUTTON.CONTINUE'),
                    showConfirmButton: true,
                    showCloseButton: true,
                    callback: () => {
                        this.$router.push({
                            name: 'applicationNew',
                            query: { appTypeKey: 'AUTORIZATIE_CONSTRUIRE' },
                        });
                    },
                });
            } else {
                this.updateProfile({}).then((data) => {
                    if (data?.pcuel_link_conflict) {
                        destroyPcuelAccountId();
                        this.$alert({
                            type: 'error',
                            text: this.$t('PCUEL.CONFLICT_TEXT'),
                        });
                        return;
                    }
                    this.$alert({
                        type: 'warning',
                        text: this.$t('PCUEL.INFO_MODAL_TEXT'),
                        confirmButtonText: this.$t('GENERAL.BUTTON.CONTINUE'),
                        showConfirmButton: true,
                        showCloseButton: true,
                        callback: () => {
                            this.$router.push({
                                name: 'applicationNew',
                                query: { appTypeKey: 'AUTORIZATIE_CONSTRUIRE' },
                            });
                        },
                    });
                });
            }
        },
    },
    mounted() {
        /**
         * this is to override the layout config using saved data from localStorage
         * remove this to use config only from static json (@/core/config/layout.config.json)
         */
        this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);

    },
    async created() {
        if (this.isAuthenticated) {
            await this.fetchSettings();
        }
        await this.doInit();
        this.handleAccountIdSync();
        eventHub.$on('expiredToken', (tokenState) => {
            this.changeTokenState(tokenState);
            this.$bvModal.show('login-modal');
        });
    },
};
</script>
